import React, { lazy, Suspense, useEffect, useState } from "react";
import ToolsOpen from "./ToolsOpen";
import { useSelector } from "react-redux";
import { GettingAllTools } from "../../../allApi/api";
import CardGrid from "./ToolsShown";
import {
  Box,
  Button,
  Center,
  HStack,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  Spinner,
  Text,
} from "@chakra-ui/react";
import search_icon from "../../../assets/waveflowmain/search_icon.png";
import toggleBlueIcon from "../../../assets/tools/toggleBlueIcon.png";
import togglewhiteIcon from "../../../assets/tools/togglewhiteIcon.png";
import { commonStyle } from "../../../styles/commonStyle";

const PredefinedTools = lazy(() => import("./PredefineTools/PredefinedTools"));

function Tools() {
  const [activeTab, setActiveTab] = useState("predefined");
  const [handleSearchInput, setHandleSearchInput] = useState("");
  const [toolsList, setToolsList] = useState([]);
  const [loader, setLoader] = useState(true);
  const [addingToolId, setAddingToolId] = useState(null);

  const waveflowToolsAdd = useSelector(
    (state) => state?.waveflowSearchData?.waveflowTool
  );
  const waveFlowDelete = useSelector(
    (state) => state?.waveflowSearchData?.waveFlowToolsDelete
  );

  const handleToolSearch = (e) => {
    setHandleSearchInput(e.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await GettingAllTools();
        setToolsList(data?.tools);
      } catch (error) {
        console.error("Error fetching models:", error);
      } finally {
        setLoader(false);
      }
    };

    fetchData();
  }, [waveflowToolsAdd, waveFlowDelete]);

  return (
    <Box w={"95%"} m={"auto"} h={"90vh"}>
      <Box mt={"2px"} mb={"10px"}>
        <Text fontWeight={500}>Tools</Text>
        <HStack justifyContent={"space-between"} w={"100%"}>
          {" "}
          <Text color={"rgba(108, 114, 117, 0.75)"}>
            Tools are python functions that agents can use to solve tasks.
          </Text>
          <Box>{activeTab === "userdefined" && <ToolsOpen />}</Box>
        </HStack>
      </Box>

      <HStack w={"100%"} justifyContent={"space-between"}>
        <HStack w="30%">
          <InputGroup size="sm" border={"transparent"}>
            <InputLeftElement pointerEvents="none">
              <Image src={search_icon} w={"25px"} />
            </InputLeftElement>
            <Input
              _placeholder={{ color: "rgba(108, 114, 117, 0.5)" }}
              placeholder="Search"
              bg="gray.20"
              onChange={handleToolSearch}
            />
          </InputGroup>
        </HStack>
        <Box>
          <Button
            onClick={() => setActiveTab("predefined")}
            bg={"transparent"}
            size={"xs"}
          >
            <HStack spacing={1}>
              <Image
                draggable={false}
                src={
                  activeTab === "predefined" ? toggleBlueIcon : togglewhiteIcon
                }
                alt="Icon"
                boxSize="18px"
              />
              <Text
                color={
                  activeTab === "predefined"
                    ? "rgba(142, 53, 255, 1)"
                    : "rgba(108, 114, 117, 0.5)"
                }
              >
                PreDefined
              </Text>
            </HStack>
          </Button>
          <Button
            onClick={() => setActiveTab("userdefined")}
            bg={"transparent"}
            size={"xs"}
          >
            <HStack spacing={1}>
              <Image
                draggable={false}
                src={
                  activeTab === "userdefined" ? toggleBlueIcon : togglewhiteIcon
                }
                alt="Icon"
                boxSize="18px"
              />
              <Text
                color={
                  activeTab === "userdefined"
                    ? "rgba(142, 53, 255, 1)"
                    : "rgba(108, 114, 117, 0.5)"
                }
              >
                UserDefined
              </Text>
            </HStack>
          </Button>
        </Box>
      </HStack>
      {activeTab === "userdefined" ? (
        <>
          {loader && (
            <Box
              overflowY="auto"
              sx={{ ...commonStyle.sx, scrollBehavior: "smooth" }}
              w={"100%"}
              h={"80%"}
            >
              <Center h="50vh">
                <Spinner size="xl" />
              </Center>
            </Box>
          )}
          <Box
            overflowY="auto"
            sx={{ ...commonStyle.sx, scrollBehavior: "smooth" }}
            w={"100%"}
            h={"80%"}
          >
            <CardGrid
              toolsList={toolsList}
              addingToolId={addingToolId}
              setAddingToolId={setAddingToolId}
            />
          </Box>
        </>
      ) : (
        <Box w={"100%"} h={"84%"} m={"auto"}>
          <Suspense
            fallback={
              <Center h="50vh">
                <Spinner size="xl" />
              </Center>
            }
          >
            <PredefinedTools handleSearchInput={handleSearchInput} />
          </Suspense>
        </Box>
      )}
    </Box>
  );
}

export default Tools;
